import { Injectable, inject } from '@angular/core';
import { SidebarState } from '../state/sidebar.state';
import {
  QueryParamsDto,
  QueryParamsKeys,
} from './model/sidebar-query-params.model';
import { ISidebarState } from '../state/model/sidebar-state.model';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsToStateService {
  private readonly sidebarState = inject(SidebarState);

  convertQueryParamsToState(sidebarQueryParams: QueryParamsDto): ISidebarState {
    const result: ISidebarState = {
      searchString:
        sidebarQueryParams[QueryParamsKeys.sidebarSearchString] ??
        this.sidebarState.searchString(),
      taskTypesSelection:
        sidebarQueryParams[QueryParamsKeys.sidebarTaskTypesSelection] ??
        this.sidebarState.taskTypesSelection(),
      taskOwnership:
        sidebarQueryParams[QueryParamsKeys.sidebarTaskOwnership] ??
        this.sidebarState.taskOwnership(),
      activeTab:
        sidebarQueryParams[QueryParamsKeys.sidebarActiveTab] ??
        this.sidebarState.activeTab(),
      collapsed: this.sidebarState.collapsed(),
    };
    return result;
  }

  convertStateToQueryParams(uiState: ISidebarState): QueryParamsDto {
    return {
      sidebarActiveTab: uiState.activeTab,
      sidebarSearchString: uiState.searchString,
      ...(uiState.taskTypesSelection.length > 0
        ? { sidebarTaskTypesSelection: uiState.taskTypesSelection }
        : {}),
      sidebarTaskOwnership: uiState.taskOwnership,
    };
  }
}
